import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

// TODO on push
@Component({
  standalone: false,
  selector: 'lib-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
